import styled from 'styled-components';

export const StyledFinishStep = styled.div`
  .finish-step-container {
    display: flex;
    justify-content: center;
    gap: 1rem;
  }

  .finish-step-item {
    display: flex;
    align-items: center;
    gap: 12px;
    border-radius: 8px;

    .icon-wrapper {
      width: 32px;
      height: 32px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 50%;
      flex-shrink: 0;
    }
  }

  .finish-step-content {
    margin-top: 2rem;
    padding: 2rem;

    img {
      width: 100%;
    }
  }
`;
